import { BRANDS } from "../data/site";

export function Marquee() {
  const row = BRANDS.map((brand) => (
    <span
      key={brand}
      className="flex items-center gap-10 sm:gap-16 pr-10 sm:pr-16"
    >
      <span className="font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-wide text-white/25 whitespace-nowrap">
        {brand}
      </span>
      <span className="w-2.5 h-2.5 bg-[#FF5500] rotate-45 shrink-0" />
    </span>
  ));
  return (
    <section
      className="marquee-band py-6 sm:py-8"
      aria-label="Tyre brands we fit"
      data-testid="brand-marquee"
    >
      <div className="marquee-track">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </section>
  );
}
